import { Select } from 'antd'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useGetIspsQuery } from '../redux/apis/domainsManagement/isp/dMIspApiSlice'

const IspDropdown = ({ onChange, onBlur, value, disabled, className, label='ISP' }) => {
  const { data, isLoading, error } = useGetIspsQuery({
    fields: ['id','isp_name','country'],
    expand: ['country'],
    page: '*',
  })

  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3 flex-1'>
      <label className="form-label">{label}</label>
      <br />
      <Select
      className={className}
        name='isp'
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: `${x.isp_name} - ${x.country.country_name}`, value: x.id }
        })}
        disabled={disabled}
      />
    </div>
  )
}

export default IspDropdown
